import { ReactNode } from 'react';
import styles from '../../dashboard/Dashboard.module.scss';

interface ChartContainerProps {
  children: ReactNode;
  height?: number;
}

export const ChartContainer = ({ children, height = 320 }: ChartContainerProps) => (
  <div className={styles.chartContainer} style={{ minHeight: height, height }}>
    {children}
  </div>
);
